'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = undefined;

var _jsx2 = require('babel-runtime/helpers/jsx');

var _jsx3 = _interopRequireDefault(_jsx2);

var _toConsumableArray2 = require('babel-runtime/helpers/toConsumableArray');

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp2;
// import classNames from 'classnames';


var _components = require('../../components');

var _reactIntl = require('react-intl');

var _urls = require('../../utils/urls');

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propsComparer = require('../../utils/propsComparer');

var _propsComparer2 = _interopRequireDefault(_propsComparer);

var _CardCta = require('./CardCta');

var _CardCta2 = _interopRequireDefault(_CardCta);

var _CardStatusBanner = require('./CardStatusBanner');

var _CardStatusBanner2 = _interopRequireDefault(_CardStatusBanner);

var _noop = require('../../utils/noop');

var _noop2 = _interopRequireDefault(_noop);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _safelyRender = require('../../utils/safelyRender');

var _safelyRender2 = _interopRequireDefault(_safelyRender);

var _ItemCard = require('./ItemCard.scss');

var _ItemCard2 = _interopRequireDefault(_ItemCard);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// potential cases for item cards
/*
    - in a 'live' auction
        - available                                         -live-available
        - sold                                              -live-sold
        - passed                                            -live-passed

    - in an 'online' auction
        - less than 24 hours before the auction starts      -online-soon
        - more than 24 hours before the auction starts      -online-upcoming

    - in a 'done' auction
        - sold                                              -done-sold
        - passed                                            -done-passed

    also, there may be modifiers for search cards

*/

var ItemCard = (_temp2 = _class = function (_Component) {
    (0, _inherits3.default)(ItemCard, _Component);

    function ItemCard() {
        var _ref;

        var _temp, _this, _ret;

        (0, _classCallCheck3.default)(this, ItemCard);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = ItemCard.__proto__ || (0, _getPrototypeOf2.default)(ItemCard)).call.apply(_ref, [this].concat(args))), _this), _this.showSendSellerMessageModal = function () {
            var _this$props = _this.props,
                cardViewModel = _this$props.cardViewModel,
                openSendSellerMessageModal = _this$props.openSendSellerMessageModal;
            var catalog = cardViewModel.catalog,
                seller = cardViewModel.seller;
            var sellerId = seller.sellerId,
                sellerName = seller.name;


            var messageDetails = {};
            var subject = _this.context.intl.formatMessage({
                id: 'registration_declined'
            }) + ': ' + catalog.title;

            openSendSellerMessageModal(messageDetails, sellerId, sellerName, subject);
        }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
    }

    (0, _createClass3.default)(ItemCard, [{
        key: 'shouldComponentUpdate',
        value: function shouldComponentUpdate(nextProps) {
            var _props$cardViewModel = this.props.cardViewModel,
                cardViewModel = _props$cardViewModel === undefined ? {} : _props$cardViewModel;
            var nextCardViewModel = nextProps.cardViewModel;
            var biddingInfo = cardViewModel.biddingInfo,
                catalog = cardViewModel.catalog,
                item = cardViewModel.item,
                seller = cardViewModel.seller;


            return (0, _propsComparer2.default)(this.props, nextProps, ['className', 'hideLotNumbers', 'hideSeller', 'last', 'showBidStatus', 'showCta']) || (0, _propsComparer2.default)(biddingInfo, nextCardViewModel.biddingInfo, ['bidActivityCount', 'leadingBid']) || (0, _propsComparer2.default)(item, nextCardViewModel.item, ['itemId']) || (0, _propsComparer2.default)(seller, nextCardViewModel.seller, ['sellerId']) || (0, _propsComparer2.default)(catalog, nextCardViewModel.catalog, ['catalogId']);
        }
    }, {
        key: 'render',
        value: function render() {
            var _props = this.props,
                cardViewModel = _props.cardViewModel,
                className = _props.className,
                hideLotNumbers = _props.hideLotNumbers,
                hideSeller = _props.hideSeller,
                last = _props.last,
                openAbstenteeBidModal = _props.openAbstenteeBidModal,
                openRetractBidModal = _props.openRetractBidModal,
                showBidStatus = _props.showBidStatus,
                showCta = _props.showCta,
                trackClick = _props.trackClick;
            var biddingInfo = cardViewModel.biddingInfo,
                catalog = cardViewModel.catalog,
                catalogRegistration = cardViewModel.catalogRegistration,
                item = cardViewModel.item,
                seller = cardViewModel.seller;
            var bidActivityCount = biddingInfo.bidActivityCount,
                leadingBid = biddingInfo.leadingBid;
            var catalogId = catalog.catalogId,
                catalogStatus = catalog.catalogStatus,
                _catalog$currency = catalog.currency,
                currency = _catalog$currency === undefined ? 'usd' : _catalog$currency,
                saleStartTs = catalog.saleStartTs,
                catalogTitle = catalog.title;
            var imageVersion = item.imageVersion,
                isAvailable = item.isAvailable,
                isPassed = item.isPassed,
                isSold = item.isSold,
                itemId = item.itemId,
                lotNumber = item.lotNumber,
                photo = item.photo,
                photos = item.photos,
                salePrice = item.salePrice,
                startPrice = item.startPrice,
                title = item.title;
            var sellerId = seller.sellerId,
                sellerName = seller.name;


            var firstPhoto = void 0;
            if (photo) {
                // came from the catalog page items
                firstPhoto = photo;
            } else if (photos && photos.length > 0) {
                firstPhoto = photos[0];
            } else {
                firstPhoto = '';
            }

            var classes = [].concat((0, _toConsumableArray3.default)(className.split(' ')), [_ItemCard2.default['item-card'], !item.title ? _ItemCard2.default.placeholder : '', last ? _ItemCard2.default['last-card'] : '']).join(' ').trim();
            var currentPrice = leadingBid || salePrice || startPrice || 0;
            var safeTitle = (0, _safelyRender2.default)(title, 'span');
            var safeSellerName = (0, _safelyRender2.default)(sellerName, 'span');
            var itemUrl = (0, _urls.getItemUrl)(itemId, title);
            var imageUrl = (0, _urls.getItemCardImageUrl)(sellerId, catalogId, itemId, firstPhoto, imageVersion);
            var lotNumberDisplay = lotNumber ? (0, _jsx3.default)(_components.Link, {
                className: _ItemCard2.default['lot-number'],
                route: true,
                to: itemUrl,
                primaryWeak: true
            }, void 0, (0, _jsx3.default)(_reactIntl.FormattedMessage, {
                id: 'lot'
            }), '\xA0', lotNumber) : (0, _jsx3.default)('span', {
                className: _ItemCard2.default['lot-number']
            }, void 0, '\xA0', '0000');

            return (0, _jsx3.default)('div', {
                className: classes,
                onClick: trackClick
            }, void 0, (0, _jsx3.default)(_components.Link, {
                className: _ItemCard2.default['item-image-link-container'],
                route: true,
                to: itemUrl
            }, void 0, (0, _jsx3.default)('div', {
                className: _ItemCard2.default['image-container']
            }, void 0, (0, _jsx3.default)(_components.ImageWithFallback, {
                alt: title,
                className: _ItemCard2.default.image,
                forceFallback: !item,
                src: imageUrl
            }), showBidStatus && (0, _jsx3.default)(_CardStatusBanner2.default, {
                biddingInfo: biddingInfo,
                catalogRegistration: catalogRegistration,
                item: item
            }))), (0, _jsx3.default)('div', {
                className: _ItemCard2.default['item-title-container']
            }, void 0, title ? (0, _jsx3.default)(_components.Link, {
                className: _ItemCard2.default['item-title'],
                route: true,
                to: itemUrl,
                primary: true
            }, void 0, safeTitle) : (0, _jsx3.default)('span', {
                className: _ItemCard2.default['item-title']
            }, void 0, 'Lorem ipsum dolor sit amet, consectetur adipiscing elit'), (0, _jsx3.default)(_components.ItemSaveContainer, {
                className: _ItemCard2.default['item-save'],
                itemId: itemId
            })), (0, _jsx3.default)('div', {
                className: _ItemCard2.default['item-bids-container']
            }, void 0, isAvailable ? (0, _jsx3.default)('span', {
                className: _ItemCard2.default['item-current-bid-container']
            }, void 0, (0, _jsx3.default)('span', {
                className: _ItemCard2.default['item-current-bid']
            }, void 0, (0, _jsx3.default)(_reactIntl.FormattedNumber, {
                value: currentPrice,
                style: 'currency',
                currency: currency,
                maximumFractionDigits: 0,
                minimumFractionDigits: 0
            })), bidActivityCount === 0 ? '' : (0, _jsx3.default)('span', {
                className: _ItemCard2.default['item-bid-count']
            }, void 0, bidActivityCount, '\xA0', bidActivityCount === 1 ? (0, _jsx3.default)(_reactIntl.FormattedMessage, {
                id: 'bid'
            }) : (0, _jsx3.default)(_reactIntl.FormattedMessage, {
                id: 'bids'
            }))) : (0, _jsx3.default)('span', {
                className: _ItemCard2.default['item-sold-bid-container']
            }, void 0, (0, _jsx3.default)('span', {
                className: _ItemCard2.default['item-sold-bid']
            }, void 0, !!isPassed && (0, _jsx3.default)(_components.ItemPriceGatewayContainer, {
                itemCard: true,
                containerClassName: _ItemCard2.default['price-gateway-container']
            }, void 0, (0, _jsx3.default)(_reactIntl.FormattedMessage, {
                id: 'lot_passed'
            })), !!isSold && (0, _jsx3.default)(_components.ItemPriceGatewayContainer, {
                itemCard: true,
                containerClassName: _ItemCard2.default['price-gateway-container']
            }, void 0, (0, _jsx3.default)('span', {}, void 0, (0, _jsx3.default)(_reactIntl.FormattedMessage, {
                id: 'sold_for'
            }, 0), '\xA0', (0, _jsx3.default)(_reactIntl.FormattedNumber, {
                value: salePrice,
                style: 'currency',
                currency: currency,
                maximumFractionDigits: 0,
                minimumFractionDigits: 0
            }, 1)))))), (0, _jsx3.default)('div', {
                className: _ItemCard2.default['catalog-countdown-container']
            }, void 0, catalogStatus === 'live' ? (0, _jsx3.default)('span', {
                className: _ItemCard2.default['item-is-live']
            }, void 0, (0, _jsx3.default)(_components.BidConsoleOpener, {
                catalogId: catalogId
            }, void 0, (0, _jsx3.default)('span', {
                className: _ItemCard2.default['item-is-live-link']
            }, void 0, (0, _jsx3.default)(_reactIntl.FormattedMessage, {
                id: 'live'
            })))) : (0, _jsx3.default)(_components.CatalogDate, {
                date: saleStartTs
            })), (0, _jsx3.default)('div', {
                className: _ItemCard2.default['auctioneer-link-container']
            }, void 0, !hideLotNumbers && lotNumberDisplay, !hideSeller && (0, _jsx3.default)('span', {
                className: _ItemCard2.default['auctioneer-name-container']
            }, void 0, !hideLotNumbers && (0, _jsx3.default)('span', {
                className: _ItemCard2.default.pipe
            }, void 0, '|'), sellerName ? (0, _jsx3.default)(_components.Link, {
                className: _ItemCard2.default['auctioneer-link'],
                route: true,
                to: (0, _urls.getSellerUrl)(sellerId, sellerName),
                primaryWeak: true
            }, void 0, safeSellerName) : (0, _jsx3.default)('span', {
                className: _ItemCard2.default['auctioneer-link']
            }, void 0, 'Jasper52'))), showCta && (0, _jsx3.default)(_CardCta2.default, {
                biddingInfo: biddingInfo,
                catalogId: catalogId,
                catalogRegistration: catalogRegistration,
                catalogStatus: catalogStatus,
                catalogTitle: catalogTitle,
                currency: currency,
                item: item,
                itemUrl: itemUrl,
                openAbstenteeBidModal: openAbstenteeBidModal,
                openRetractBidModal: openRetractBidModal,
                sellerId: sellerId,
                sellerName: sellerName,
                showSendSellerMessageModal: this.showSendSellerMessageModal
            }));
        }
    }]);
    return ItemCard;
}(_react.Component), _class.contextTypes = {
    intl: _propTypes2.default.object.isRequired
}, _class.defaultProps = {
    cardViewModel: {
        biddingInfo: {},
        catalog: {
            currency: 'usd'
        },
        catalogRegistration: {},
        item: {
            salePrice: 0,
            title: ''
        },
        seller: {}
    },
    className: '',
    hideLotNumbers: false,
    hideSeller: false,
    last: false,
    openAbstenteeBidModal: _noop2.default,
    openRetractBidModal: _noop2.default,
    openSendSellerMessageModal: _noop2.default,
    showBidStatus: false,
    showCta: false,
    trackClick: _noop2.default
}, _temp2);
exports.default = ItemCard;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/ItemCard/ItemCard.js
// module id = g2OR
// module chunks = 46